<template>
  <div class="form-content">
    <!-- 微信认证组件 -->
    <wxAuth :share="share"></wxAuth>
    <!-- title -->
    <headers :params="hraderP"></headers>
    <div class="result-content">
      <div class="hint">根据您的需求，预计设计费用为</div>
      <div class="mount-wrap">
        <!-- <span class="mount-icon">¥</span> -->
        <span class="mount">{{query.budget}}</span>
      </div>
      <van-row class="project-stage-wrap" v-if="stage">
        <van-col
          span="24"
          v-if="stage === 1"
        >*方案设计阶段交付成果类型：文字方案（DOC文件）、汇报方案（PPT文件）、根据建筑面积计算的系统估算清单（XLS文件）。</van-col>
        <van-col
          span="24"
          v-if="stage === 2"
        >*初步设计阶段交付成果类型：文字方案（DOC文件）、汇报方案（PPT文件）、不含管线桥架设计的设备点位平面布置图及系统示意图（DWG文件）、根据建筑面积或点位布置图计算系统估算或概算清单（XLS文件）。</van-col>
        <van-col
          span="24"
          v-if="stage === 3"
        >*施工图设计阶段交付成果类型：文字方案（DOC）、汇报方案（PPT文件）、基于甲方提供的设计院施工图（和二次装修图）设计的整套智能化专项设计图纸、根据施工图阶段设计的图纸统计的系统预算清单（XLS文件，客户特殊要求的另外满足）。</van-col>
        <van-col
          span="24"
          v-if="stage === 4"
        >*深化设计阶段交付成果类型：根据项目实际进度提供所需的满足现场施工要求的各类图纸（DWG文件）、配置清单（XLS文件，客户特殊要求的另外满足）等等。</van-col>
      </van-row>
    </div>
    <div class="title-wrap">
      <span class="title">联系人信息</span>
      <span class="desc">填写准确的信息使我们更快速找到您</span>
    </div>
    <van-row class="form-item-row">
      <van-col :span="6" class="title">联系人</van-col>
      <van-col :span="18" class="value">
        <input v-model="query.contacts" placeholder="请填写联系人姓名" maxlength="11" />
      </van-col>
    </van-row>
    <van-row class="form-item-row">
      <van-col :span="6" class="title">联系方式</van-col>
      <van-col :span="18" class="value">
        <input v-model="query.mobile" oninput="value=(value.replace(/[^\d]/g,'')).slice(0,9)" placeholder="请填写联系人手机号" maxlength="11" />
      </van-col>
    </van-row>
    <div class="result-hint">*该报价仅供参考，若需要更为准确报价请点击提交需求按钮近一步沟通</div>
    <div class="bottom-style"></div>
    <van-row class="form-item-button">
      <van-col :span="24">
        <button @click="submitDemand">我要设计</button>
      </van-col>
    </van-row>
  </div>
</template>

<script>
import headers from '@/components/headers'
import wxAuth from '@/components/wxAuth'
import { updateContacts } from '@/api/offerForm/offerForm'
import { Row, Col, Toast, Notify } from 'vant'
import { mapState } from 'vuex'
export default {
  name: 'add-demand-form',
  components: {
    Row,
    Col,
    Toast,
    Notify,
    wxAuth,
    headers
  },
  computed: {
    ...mapState({
      API2DomainUrl: (state) => state.baseData.API2DomainUrl,
      token: (state) => state.user.ticket,
      userId: (state) => state.user.AccountId,
      userName: (state) => state.user.AccountName
    })
  },
  data () {
    return {
    //   share: {
    //     title: '设计报价器',
    //     desc:
    //       '智能化产品方案,产品方案,系统方案,弱电设备方案,厂商方案,产品供应商设计方案,弱电设计方案,热门方案,规划设计方案,顶层设计方案,系统解决方案,集成商方案,招标方案,投标方案,深化设计方案,施工方案',
    //     imgUrl:
    //       'https://image01.homedo.com/Files/Images/cms/www/20171225/4970465306687879653_pic1.jpg',
    //     url: window.location.href.split('#')[0]
    //   },
      hraderP: {
        title: '报价结果',
        lefticon: true
      },
      stage: null,
      query: {
        id: null,
        budget: null,
        contacts: null,
        mobile: null
      }
    }
  },
  created () {
    this.stage = +this.$route.params.stage
    this.query.id = this.$route.params.id
    this.query.budget = this.$route.params.budget
    console.log(this)
  },
  methods: {
    submitDemand () {
      if (!this.query.contacts || this.query.contacts === '') {
        Toast('请填写联系人姓名')
        return
      }
      if (!this.query.mobile || this.query.mobile === '') {
        Toast('请填写联系人手机号')
        return
      }
      updateContacts(this.query).then((result) => {
        console.log(result)
        if (result.status === 200) {
          if (result.data && result.data.respCode === '0000') {
            console.log(result)
            this.$router.replace('/demand/success.html')
          } else {
            result.data.respDesc
              ? Notify(result.data.respDesc)
              : Notify('提交失败')
          }
        } else {
          Notify('提交失败')
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.form-content {
  .result-content {
    background: white;
    overflow: hidden;
  }
  .hint {
    font-size: 15px;
    color: #777777;
    text-align: center;
    margin-top: 20px;
  }
  .mount-wrap {
    margin-top: 30px;
    line-height: 50px;
    color: #ff0000;
    text-align: center;

    .mount {
      font-size: 40px;
      font-weight: 600;
      line-height: 50px;
      &::before {
        content: "¥";
        vertical-align: top;
        margin-right: 6px;
        font-size: 20px;
        line-height: 50px;
      }
    }
  }
  .form-item {
    &-row {
      border-top: 1px solid #e5e5e5;
      background-color: white;
      .title {
        height: 44px;
        line-height: 44px;
        padding-left: 3%;
        padding-right: 3%;
        font-size: 17px;
        color: #000000;
      }
      .value {
        height: 44px;
        line-height: 44px;
        padding-left: 0;
        padding-right: 3%;
        input {
          width: 92%;
          font-size: 0.426667rem;
          border: none;
          overflow: hidden;
          text-overflow: ellipsis;
          display: inline-block;
          -webkit-line-clamp: 1;
          -webkit-box-orient: vertical;
        }
      }
    }
    &-button {
      width: 100%;
      position: fixed;
      bottom: 20px;
      button {
        display: block;
        width: 90%;
        margin: 0 auto;
        border: none;
        height: 40px;
        background-color: #007cff;
        color: white;
        font-size: 18px;
      }
    }
  }
  .title-wrap {
    height: 44px;
    line-height: 44px;
    padding-left: 3%;
    padding-right: 3%;
    font-size: 17px;
    color: #000000;
    position: relative;
    background: white;
    margin-top: 10px;
    .title {
      padding-left: 10px;
      &::before {
        content: "";
        position: absolute;
        width: 4px;
        height: 18px;
        background: #2f7bff;
        top: 11px;
        left: 13px;
      }
    }
    .desc {
      font-size: 12px;
      color: #cfcfd8;
      margin-left: 6px;
    }
  }
  .project-stage-wrap {
    margin-top: 13px;
    font-size: 12px;
    color: #1e1f22;
    padding: 15px;
  }
  .result-hint{
    font-size: 12px;
    color: #AFAFB4;
    padding: 15px;
  }
  .bottom-style {
    height: 50px;
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/offerForm/result.vue